export default __webpack_public_path__ + "static/media/G0590.34I-26338_-16194_0.1666262520000.7f155fe8.jpg";